import { createTransform } from 'redux-persist';

import { isRelationshipMapping } from 'src/containers/ProjectDiagram/utils/data';
import {
  getAllDomainsAndRanges,
  isValidMappingDomainAndRange,
} from 'src/containers/ProjectDiagram/utils/isValidDomainAndRange';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

export const pruneInvalidRelationshipMappings = createTransform<
  ReduxState['projects'],
  ProjectsState,
  ReduxState
>(
  (projectsState) => {
    const prunedProjectsById: Record<string, Project> = {};
    projectsState.projectIds.forEach((id) => {
      const project = projectsState.projectsById[id];
      if (!project) {
        return;
      }

      const { classMappingIriByKey, domainsAndRanges } = getAllDomainsAndRanges(
        project.diagram.model
      );

      const linkDataArray = project.diagram.model.linkDataArray.filter(
        (linkData) => {
          if (!isRelationshipMapping(linkData)) {
            return true;
          }

          if (
            isValidMappingDomainAndRange(
              linkData,
              classMappingIriByKey,
              domainsAndRanges
            )
          ) {
            return true;
          }

          console.warn(
            `Removing create invalid relationship mapping (iri: ${
              linkData.relationshipIri
            }, from: ${
              linkData.from
                ? classMappingIriByKey.get(linkData.from)
                : linkData.fromClassIri
            }, to: ${
              linkData.to
                ? classMappingIriByKey.get(linkData.to)
                : linkData.toClassIri
            })`
          );
          return false;
        }
      );

      prunedProjectsById[project.id] = {
        ...project,
        diagram: {
          ...project.diagram,
          model: {
            ...project.diagram.model,
            linkDataArray,
          },
        },
      };
    });

    return { ...projectsState, projectsById: prunedProjectsById };
  },
  null,
  { whitelist: ['projects'] }
);
